import React, { useContext, useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { ExamCompassContext } from '../Context/context';
import logo from '../Assets/compass-logo.svg';
// import { DecryptedAuthToken, encrypt } from '../utils/encryption';

type NavbarPropsType = {
  currentPage: string;
  setCurrentPage: React.Dispatch<React.SetStateAction<string>>;
};

const Navbar: React.FC<NavbarPropsType> = ({ currentPage, setCurrentPage }) => {
  const { about, toDashboard, logoutUser } = useContext(ExamCompassContext);
  const [showMenu, setShowMenu] = useState<boolean>(false);

  return (
    <div className='w-full bg-white fixed top-0 left-0 z-40 nav'>
      <div className='relative'>
        <div className='container flex items-center justify-between py-4'>
          <Link to={'/'}>
            <img
              className='w-[120px] md:w-[157px]'
              src={logo}
              alt='exam compass logo'
            />
          </Link>
          <div className='flex items-center'>
            <div
              className={`bg-lemonGreen lg:bg-inherit w-full md:w-[50%] lg:w-auto absolute lg:static right-0 top-0 h-[100vh] lg:h-auto flex flex-col-reverse lg:flex-row justify-center items-center gap-10 ${
                showMenu
                  ? 'translate-x-0 duration-200'
                  : 'translate-x-full duration-200'
              } lg:translate-x-0 duration-200 ease-in-out`}
            >
              <ul className='flex flex-col lg:flex-row items-center gap-9'>
                <Link
                  to={'/'}
                  onClick={() => {
                    setCurrentPage('home');
                    setShowMenu(false);
                  }}
                  className={`text-darkGreen py-1 cursor-pointer ${
                    currentPage === 'home' ? 'border-b-2 border-lemonGreen' : ''
                  }`}
                >
                  Home
                </Link>
                <Link
                  to={'/about'}
                  onClick={() => {
                    setCurrentPage('about');
                    setShowMenu(false);
                  }}
                  className={`text-darkGreen py-1 cursor-pointer  ${
                    currentPage === 'about'
                      ? 'border-b-2 border-lemonGreen'
                      : ''
                  }`}
                >
                  About Us
                </Link>
                <HashLink
                  smooth
                  to={'/#how-it-works'}
                  onClick={() => {
                    setCurrentPage('features');
                    setShowMenu(false);
                  }}
                  className={`text-darkGreen py-1 cursor-pointer  ${
                    currentPage === 'features'
                      ? 'border-b-2 border-lemonGreen'
                      : ''
                  }`}
                >
                  Features
                </HashLink>
                <HashLink
                  smooth
                  to={'/#subscribe'}
                  onClick={() => {
                    setCurrentPage('subscribe');
                    setShowMenu(false);
                  }}
                  className={`text-darkGreen py-1 cursor-pointer ${
                    currentPage === 'subscribe'
                      ? 'border-b-2 border-lemonGreen'
                      : ''
                  }`}
                >
                  Subscribe
                </HashLink>
                <a
                  onClick={() => setShowMenu(false)}
                  href={`mailto:${about?.email || 'support@examcompassng.com'}`}
                  className='text-darkGreen py-1 cursor-pointer'
                >
                  Contact Us
                </a>
              </ul>

              <div className='flex items-center gap-7 lg:gap-3'>
                {localStorage.getItem('authToken') ||
                sessionStorage.getItem('authToken') ? (
                  <button
                    onClick={() => {
                      toDashboard && toDashboard();
                      setShowMenu(false);
                    }}
                    className='px-[18px] py-[4px] md:px-[16px] md:py-[4px] border border-darkGreen text-darkGreen rounded'
                  >
                    Dashboard
                  </button>
                ) : (
                  <Link to={'/register'} onClick={() => setShowMenu(false)}>
                    <button className='px-[18px] py-[4px] md:px-[16px] md:py-[4px] border border-darkGreen text-darkGreen rounded'>
                      Register
                    </button>
                  </Link>
                )}

                {localStorage.getItem('authToken') ||
                sessionStorage.getItem('authToken') ? (
                  <button
                    onClick={() => {
                      logoutUser && logoutUser();
                      setShowMenu(false);
                    }}
                    className='px-[18px] py-[4px] md:px-[16px] md:py-[4px] border border-red-500 text-red-500 rounded'
                  >
                    Logout
                  </button>
                ) : (
                  <Link to={'/login'} onClick={() => setShowMenu(false)}>
                    <button className='px-[18px] py-[4px] md:px-[16px] md:py-[4px] bg-darkGreen border  border-darkGreen text-white rounded'>
                      Login
                    </button>
                  </Link>
                )}
              </div>
            </div>

            <div
              onClick={() => setShowMenu(!showMenu)}
              className='text-darkGreen lg:hidden z-50'
            >
              {showMenu ? <FaTimes size={26} /> : <FaBars size={26} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
